import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import HeaderImage from '@/components/HeaderImage';
import LeafIcon from '@/components/LeafIcon';
import { homeContent } from '@/mocks/homeContent';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <HeaderImage />

      <main className="max-w-3xl mx-auto px-6 md:px-10 py-12 md:py-16">
        <h1 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-snug mb-8">
          {homeContent.heroTitle}
        </h1>

        <LeafIcon />

        {homeContent.heroText.map((text, i) => (
          <p key={i} className="font-body text-base md:text-lg text-foreground-800 leading-relaxed mb-6">
            {text}
          </p>
        ))}

        <LeafIcon />

        <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-relaxed mb-4">
          {homeContent.experienceTitle}
        </h2>

        {homeContent.experienceText.map((text, i) => (
          <p key={i} className="font-body text-base md:text-lg text-foreground-800 leading-relaxed mb-6">
            {text}
          </p>
        ))}

        <p className="font-body text-base md:text-lg text-foreground-800 leading-relaxed mb-6">
          {homeContent.retirementText}
        </p>

        <p className="font-body text-base md:text-lg text-foreground-800 leading-relaxed mb-6">
          {homeContent.servicesIntro}
        </p>

        <LeafIcon />

        <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-relaxed mb-4">
          {homeContent.conciergeTitle}
        </h2>

        {homeContent.conciergeText.map((text, i) => (
          <p key={i} className="font-body text-base md:text-lg text-foreground-800 leading-relaxed mb-6">
            {text}
          </p>
        ))}

        <p className="font-body text-base md:text-lg text-foreground-800 leading-relaxed mb-6">
          {homeContent.closing}
        </p>

        <p className="font-body text-base md:text-lg text-foreground-800 leading-relaxed mb-6">
          {homeContent.philosophy}
        </p>
      </main>

      <Footer />
    </div>
  );
}